import { api } from '.'

export async function getUsersPaged (params) {
	const response = await api.get(
		'/admin/users', { params }
	)
	return response.data
}
export async function getUserSecurityLogs (id, params) {
	const response = await api.get(
		'/admin/users/' + id + '/securitylogs', { params }
	)
	return response.data
}
export async function getRoles () {
	const response = await api.get(
		'/admin/getroles'
	)
	return response.data
}

export async function setRole (data) {
	const response = await api.post(
		'/admin/setrole', data
	)
	return response.data
}
export async function removeRole (data) {
	const response = await api.post(
		'/admin/removerole', data
	)
	return response.data
}
export async function deleteUser (data) {
	const response = await api.post(
		'/admin/deleteuser', data
	)
	return response.data
}
export async function tokenCreate (data) {
	const response = await api.post(
		'/tokens', data
	)
	return response.data
}
export async function organizationCreate (data) {
	const response = await api.post(
		'/organizations', data
	)
	return response.data
}
export async function getTokens () {
	const response = await api.get('/tokens')
	return response.data
}
export async function getOrganizations () {
	const response = await api.get('/organizations')
	return response.data
}
export async function removeToken (data) {
	const response = await api.delete('/tokens' + '/' + data.ID, data)
	return response.data
}

export async function getOidcClients () {
	const response = await api.get('/admin/oidcclients')
	return response.data
}
export async function createOidcClient (data) {
	const response = await api.post('/admin/oidcclients', data)
	return response.data
}
export async function updateOidcClient (clientId, data) {
	const response = await api.put('/admin/oidcclients/' + encodeURIComponent(clientId), data)
	return response.data
}
export async function removeOidcClient (clientId) {
	const response = await api.delete('/admin/oidcclients/' + encodeURIComponent(clientId))
	return response.data
}
